module.exports = __webpack_public_path__ + "img/licensed-yes.b7a43b18.svg";